import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MuralModel, ResponseMuralModel } from 'src/app/model/mural';
import { MuralService } from 'src/app/service/mural.service';
import { apiService } from '../../../../service/api.service'
import { DialogDataDiarioComponent } from './dialog-data-diario/dialog-data-diario.component';

@Component({
  selector: 'app-diariomural',
  templateUrl: './diariomural.component.html',
  styleUrls: ['./diariomural.component.css']
})
export class DiariomuralComponent implements OnInit {
  
  

  constructor(
    private muralService: MuralService,
    public dialog: MatDialog
  ) { }

  listMural;

  ngOnInit(): void {
    this.muralService.getDataMural().subscribe((response: ResponseMuralModel) => {
      this.listMural = response.payload;  
    },
    (err) => {
      console.log(err)
    });    

    this.listMural = this.muralService.getDataMural;
  }

  openDialog() {
    var mural = new MuralModel();
    const dialogRef = this.dialog.open(DialogDataDiarioComponent,{data: {mural: mural}});
    dialogRef.afterClosed().subscribe(result => {
      var mural = new MuralModel();
      mural = result;
      this.listMural.push(mural);

    });
  }
}
